define( function() {
	return ( /^$|\/(?:java|ecma)script/i );
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/manipulation/var/rscriptType.js
 ** module id = 857
 ** module chunks = 2
 **/